import React, { useState } from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SendIcon from "@mui/icons-material/Send";
import { Message, MessageType } from "../../apis/copilot/types";
import { sendMessage } from "../../apis/copilot/copilot";
import { useCopilotStore } from "../../store/copilot/CopilotStore";
import { useCopilotContext } from "../../hooks/useCopilotContext";
import { mergeMessages } from "./utils";

export const MessageInput: React.FC = () => {
  const [inputValue, setInputValue] = useState("");
  const { threadId, setMessages, isLoading, setIsLoading } = useCopilotStore();
  const context = useCopilotContext();

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey && !isLoading) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleSend = async () => {
    if (!context) return;
    if (inputValue.trim() === "") return;

    const newMessage: Message = {
      id: Math.random().toString(),
      type: MessageType.HUMAN_MESSAGE,
      payload: {
        content: inputValue,
        timestamp: new Date(),
      },
      rate: null,
    };

    setMessages((current) => [...current, newMessage]);

    setInputValue("");

    setIsLoading(true);

    sendMessage(
      threadId as string,
      inputValue,
      context,
      (answers: Message[]) => {
        setMessages((currentMessages) =>
          mergeMessages(currentMessages, answers)
        );
      },
      () => {
        setIsLoading(false);
      }
    );
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        p: 2,
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        bgcolor: "background.paper",
        alignItems: "center",
      }}
    >
      <TextField
        id="copilot-message-input"
        fullWidth
        variant="outlined"
        placeholder="Type a message..."
        size="small"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyPress}
        multiline
        maxRows={10}
      />
      <IconButton
        id="copilot-send-button"
        color="primary"
        onClick={handleSend}
        disabled={inputValue.trim() === "" || isLoading}
        sx={{
          bgcolor: "#5e35b1",
          color: "white",
          "&:hover": { bgcolor: "#4527a0" },
          "&.Mui-disabled": { bgcolor: "#e0e0e0" },
        }}
      >
        <SendIcon />
      </IconButton>
    </Stack>
  );
};
